import { render, staticRenderFns } from "./PaymentScheduleTier.vue?vue&type=template&id=15975bca&scoped=true&"
import script from "./PaymentScheduleTier.vue?vue&type=script&lang=ts&"
export * from "./PaymentScheduleTier.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentScheduleTier.vue?vue&type=style&index=0&id=15975bca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15975bca",
  null
  
)

export default component.exports